import { useSystemConfigGetApi } from '@/common/api/modules/systemConfig'

import Main, { MainLayoutType } from '@/components/view/layouts/page/Main'

import DetailPageLoader from '@/components/container/DetailPageLoader'
import SystemConfigForm from '@/components/container/form/modules/admin/systemConfig/SystemConfigForm'

const SystemConfigEditPage = () => {
  const { data: systemConfig, error, mutate } = useSystemConfigGetApi()

  return (
    <DetailPageLoader error={error} data={systemConfig} small>
      {systemConfig && (
        <Main type={MainLayoutType.SMALL}>
          <SystemConfigForm systemConfig={systemConfig} onRefetch={mutate} />
        </Main>
      )}
    </DetailPageLoader>
  )
}

export default SystemConfigEditPage
